module.exports = __webpack_public_path__ + "static/media/logo.6bbb151d.webp";